import axios from 'axios';

var ContentType;
(function (ContentType) {
    ContentType["Json"] = "application/json";
    ContentType["FormData"] = "multipart/form-data";
    ContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(ContentType || (ContentType = {}));
class HttpClient {
    instance;
    securityData = null;
    securityWorker;
    secure;
    format;
    constructor({ securityWorker, secure, format, ...axiosConfig } = {}) {
        this.instance = axios.create({ ...axiosConfig, baseURL: "https://auth.fizz.ca" });
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    setSecurityData = (data) => {
        this.securityData = data;
    };
    mergeRequestParams(params1, params2) {
        const method = params1.method || (params2 && params2.method);
        return {
            ...this.instance.defaults,
            ...params1,
            ...(params2 || {}),
            headers: {
                ...((method && this.instance.defaults.headers[method.toLowerCase()]) || {}),
                ...(params1.headers || {}),
                ...((params2 && params2.headers) || {}),
            },
        };
    }
    stringifyFormItem(formItem) {
        if (typeof formItem === "object" && formItem !== null) {
            return JSON.stringify(formItem);
        }
        else {
            return `${formItem}`;
        }
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            const propertyContent = property instanceof Array ? property : [property];
            for (const formItem of propertyContent) {
                const isFileType = formItem instanceof Blob || formItem instanceof File;
                formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
            }
            return formData;
        }, new FormData());
    }
    request = async ({ secure, path, type, query, format, body, ...params }) => {
        const secureParams = ((typeof secure === "boolean" ? secure : this.secure) && this.securityWorker && (await this.securityWorker(this.securityData))) || {};
        const requestParams = this.mergeRequestParams(params, secureParams);
        const responseFormat = (format && this.format) || void 0;
        if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
            body = this.createFormData(body);
        }
        return this.instance.request({
            ...requestParams,
            headers: {
                ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
                ...(requestParams.headers || {}),
                ...({ "Access-Control-Allow-Origin": "*" })
            },
            params: query,
            responseType: responseFormat,
            data: body,
            url: path,
        });
    };
}
class ApiOkta extends HttpClient {
    apiOkta = {
        /**
         * No description
         *
         * @tags Channel
         * @name ChannelClientCreate
         * @summary Returns channels for specific session ID
         * @request POST:/api/channel/client
         * @response `200` `Channels` Channel list
         */
        getDevice: (data, params = {}) => this.request({
            path: `/oauth2/aus4ah1q96x2bjArV697/v1/device/authorize`,
            method: "POST",
            body: data,
            type: ContentType.UrlEncoded,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags Channel
         * @name ChannelClientCreate
         * @summary Returns channels for specific session ID
         * @request POST:/api/channel/client
         * @response `200` `Channels` Channel list
         */
        getToken: (data, params = {}) => this.request({
            path: `/oauth2/aus4ah1q96x2bjArV697/v1/token`,
            method: "POST",
            body: data,
            type: ContentType.UrlEncoded,
            format: "json",
            ...params,
        }),
    };
}

export { ApiOkta, ContentType, HttpClient };
